<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import '@/assets/styles/main.scss';
import 'bulma-helpers/css/bulma-helpers.min.css';

export default {
  name: 'app',
};
</script>

<style>
html, body {
  margin: 0;
  height: 100%;
}
#app {
  height: 100%;
  font-family: "Nunito", 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
